import React from "react";
import styled from "styled-components";

export default styled.input`
    width: 100%;
    height: 40px;
    padding: 10px;
   
`;